import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

export default function Testimonials() {
  return (
    <Box
      id="testimonials"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box sx={{ width: { sm: "100%", md: "60%" }, textAlign: "center" }}>
          <Typography component="h2" variant="h4" gutterBottom>
            What Our Clients Say
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            Hear directly from teams using Savac Plus to transform their sales
            coaching.
          </Typography>
        </Box>
        <Box
          sx={(theme) => ({
            width: "100%",
            maxWidth: 720,
            aspectRatio: "16 / 9",
            borderRadius: 2,
            overflow: "hidden",
            border: "1px solid",
            borderColor: theme.palette.grey[200],
            boxShadow: "0 0 12px 8px hsla(220, 25%, 80%, 0.2)",
            ...theme.applyStyles("dark", {
              borderColor: theme.palette.grey[700],
              boxShadow: "0 0 24px 12px hsla(210, 100%, 25%, 0.2)",
            }),
          })}
        >
          <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/1182363217?h=62ccb524f4&title=0&byline=0&portrait=0"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              display: "block",
            }}
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            allowFullScreen
          />
        </Box>
      </Container>
    </Box>
  );
}
